import { useTrackingEventsDatas } from "./useTracking";
import { useTrackingEvent } from "./useTrackingEvent";
export const useTrackingCallbackAnswered = (av_zone) => {
    const EVENT_DATA = {
        event: "request_callback_contact_success",
        av_zone,
        ...useTrackingEventsDatas({
            displayMedium: true,
            conversionType: "phone",
        }),
    };
    // request_callback_contact_success does not exist as a type in the ThorEventGA4Interface
    // so we cast to unknown on purpose
    // TODO: Check with team responsible for @aviv-dxp/react-thor should we add that into the typing
    return useTrackingEvent(EVENT_DATA);
};
